import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface ScratchFactProps {
  fact: string;
  index: number;
}

export function ScratchFact({ fact, index }: ScratchFactProps) {
  const [isRevealed, setIsRevealed] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      className="relative"
    >
      <div
        className={`
          relative overflow-hidden rounded-xl p-4
          bg-space-light border border-cosmic-purple/30
          ${!isRevealed ? 'cursor-pointer hover:border-cosmic-purple/60' : ''}
          transition-all duration-300
        `}
        onClick={() => !isRevealed && setIsRevealed(true)}
      >
        {/* Revealed content */}
        <AnimatePresence>
          {isRevealed && (
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              className="flex gap-3"
            >
              <span className="text-2xl flex-shrink-0">💡</span>
              <p className="text-gray-300">{fact}</p>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Hidden/Scratch overlay */}
        <AnimatePresence>
          {!isRevealed && (
            <motion.div
              initial={{ opacity: 1 }}
              exit={{
                opacity: 0,
                scale: 1.1,
                filter: 'blur(10px)',
              }}
              transition={{ duration: 0.4 }}
              className="flex gap-3 items-center"
            >
              <div className="flex-1 relative">
                {/* Blurred preview text */}
                <p
                  className="text-gray-500 select-none"
                  style={{
                    filter: 'blur(6px)',
                    WebkitUserSelect: 'none',
                  }}
                >
                  {fact.slice(0, 50)}...
                </p>

                {/* Scratch overlay */}
                <div
                  className="absolute inset-0 flex items-center justify-center"
                  style={{
                    background: 'repeating-linear-gradient(45deg, rgba(139, 92, 246, 0.1), rgba(139, 92, 246, 0.1) 10px, rgba(139, 92, 246, 0.2) 10px, rgba(139, 92, 246, 0.2) 20px)',
                  }}
                >
                  <motion.div
                    animate={{
                      scale: [1, 1.05, 1],
                    }}
                    transition={{
                      duration: 1.5,
                      repeat: Infinity,
                      repeatDelay: 1,
                    }}
                    className="bg-cosmic-purple/90 px-4 py-2 rounded-lg shadow-lg"
                  >
                    <span className="text-white font-medium text-sm flex items-center gap-2">
                      <span>👆</span>
                      Нажми, чтобы узнать!
                    </span>
                  </motion.div>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </motion.div>
  );
}
